module.exports = __webpack_public_path__ + "static/media/country_ng.28fb547d.webp";